export enum LocalStorage {
  HAS_EVER_LOGGED_IN = 'has_ever_logged_in',
}
